import { render, staticRenderFns } from "./PlayerProfile.vue?vue&type=template&id=41774929"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme0DesktopPagesProfilePage: require('/app/components/Theme0/Desktop/Pages/ProfilePage.vue').default})
